import React from 'react'
import styled from 'styled-components'
import { Cell, Grid } from 'react-mdl'

const ImageGrid = styled(Grid)`
  background-color: ${({ selected }) => (selected ? 'lightblue' : 'initial')};
`
const ImageItem = ({
  selected,
  description = '',
  tags = [],
  _id,
  mediaId = _id,
  showDescription = true,
}) => (
  <ImageGrid selected={selected}>
    <Cell col={showDescription ? 5 : 12}>
      <img
        style={{ maxWidth: '100%' }}
        alt={`${description} - ${tags.join(', ')}`}
        src={`/images/thumbnail/${mediaId}`}
      />
    </Cell>
    {showDescription && (
      <Cell col={7}>
        <p>
          <b>{description}</b>
        </p>
        <p>{tags.join(', ')}</p>
      </Cell>
    )}
  </ImageGrid>
)

export default ImageItem



// WEBPACK FOOTER //
// ./src/components/ImageSelectionModal/ImageItem.js